const toParamsString = params => {
  let queryString = Object.keys(params)
    .map(key => key + "=" + params[key])
    .join("&");
  return queryString;
};

export { toParamsString };
